import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/document.svg'


const _hoisted_1 = {
  key: 0,
  class: "img-wrap"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-fileupload-file-details" }
const _hoisted_4 = { class: "p-fileupload-file-name" }
const _hoisted_5 = {
  key: 2,
  class: "img-loaderwrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isImage ==true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.downloadFile($setup.Props.Id))),
            src: $setup.blobUrl,
            onChangeOnce: $setup.Fileloaded,
            height: 35,
            width: 35
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.isImage ==false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "p-fileupload-file",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.downloadFile($setup.Props.Id)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "img-wrap" }, [
            _createElementVNode("img", {
              role: "presentation",
              src: _imports_0,
              class: "p-fileupload-file-thumbnail"
            })
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.Props.Name), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ProgressSpinner, {
            class: "small-loader",
            strokeWidth: "5"
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}